const data = ['grom', 'grommet'];

export default data;
